import CrawlerScheduleSettings from "./CrawlerScheduleSettings";
import StoreTabDaysSettings from "./StoreTabDaysSettings";

export default function RetailerSettingsTab() {
  return (
    <div className="space-y-5">
      <StoreTabDaysSettings />
      <CrawlerScheduleSettings />
    </div>
  );
}
